export default __webpack_public_path__ + "static/besace.inspirations-e5a6096144dfa2311113afb057c76ac2.jpg";